import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Boxes, Cable, Cpu, House, Lightbulb, Plug, ServerCog, ShieldHalf, ToggleLeft, ToggleRight, Zap } from "lucide-react";
import { asArray } from "@/lib/api";
import { useFetch } from "@/lib/hooks";

const ICONS = {
  "Cables and Wires": Cable, Switchgear: ToggleRight, Lighting: Lightbulb, "Electrical Accessories": Plug, "Cable Accessories": Zap,
  "Earthing Materials": ShieldHalf, "Industrial Products": Boxes, "Automation Products": Cpu, "Electrical Panels and Components": ServerCog,
  Switches: ToggleLeft, "Home Automation": House,
};

export function CategoriesV2() {
  const { data, loading } = useFetch("/categories", []);
  const cats = asArray(data);
  if (loading) return <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">{Array.from({ length: 6 }, (_, i) => <div key={i} className="ph2-shimmer h-28 rounded-3xl" />)}</div>;
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3" data-testid="v2-categories-grid">
      {cats.map((c, i) => {
        const Icon = ICONS[c.name] || Boxes;
        return (
          <motion.div key={c.slug} initial={{ opacity: 0, y: 18 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }} transition={{ duration: 0.45, delay: (i % 3) * 0.05 }}>
            <Link to={`/brands?category=${encodeURIComponent(c.name)}`} data-testid={`category-chip-${c.slug}`}
              className="group flex items-center gap-4 rounded-3xl border border-ph-line bg-ph-surface/70 p-5 transition-[border-color,background-color,transform] duration-300 hover:-translate-y-1 hover:border-ph-accent/50 hover:bg-ph-surface">
              <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-ph-raised text-ph-accent transition-[background-color,color] duration-300 group-hover:bg-ph-lime group-hover:text-ph-navy"><Icon className="h-5 w-5" /></span>
              <span className="min-w-0 flex-1">
                <span className="block font-semibold text-ph-ink">{c.name}</span>
                <span className="text-sm text-ph-muted">{c.brand_count} brands · {c.doc_count} lists</span>
              </span>
              <ArrowUpRight className="h-4 w-4 text-ph-muted transition-transform group-hover:rotate-45 group-hover:text-ph-accent" />
            </Link>
          </motion.div>
        );
      })}
    </div>
  );
}
